export default`

  min-width: initial;

  svg path {
    stroke: none;
    fill: rgb(0, 118, 53);
  }

  &:hover {
    svg path {
      stroke: none;
      fill: rgb(255, 255, 255);
    }
  }
`;
